// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"a55da983","453":"809a7fa7"}[chunkId] + ".chunk.js";
};